import OCProfilesTable from 'pages/ga/ocProfiles/new/OCProfilesTable';
import OCProfileAdd from 'pages/ga/ocProfiles/new/OCProfileAdd';
import OCProfileEdit from 'pages/ga/ocProfiles/new/OCProfileEdit';
import ConsentView from 'pages/ga/ocProfiles/new/components/ConsentView';

const OCProfilesRoutes = [
    {
        index: true,
        element: <OCProfilesTable />,
    },
    {
        path: 'add',
        element: <OCProfileAdd />,
    },
    {
        path: ':profileId',
        element: <OCProfileEdit />,
    },
    {
        path: ':profileId/consents/:consentId',
        element: <ConsentView />,
    },
];

export default OCProfilesRoutes;
